import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import Button from '@material-ui/core/Button'
import { makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import React from 'react'
import Popout from '../Popout'

const useStyles = makeStyles((theme: Theme) => ({
    popoutBody: {
        padding: theme.spacing(1, 2),
        marginRight: theme.spacing(0.5),
        width: pxToRem(80),
    },
    menuItem: {
        color: theme.palette.secondary.main,
        cursor: 'pointer',
        transition: '200ms',
        padding: theme.spacing(1, 1),
        marginLeft: -theme.spacing(1),
        marginRight: -theme.spacing(1),
        width: pxToRem(64),
        '&:hover': {
            borderRadius: 4,
            backgroundColor: 'rgba(0,0,0,0.2)',
        },
    },
    popoutButton: {
        color: theme.palette.secondary.main,
        padding: 0,
        fontWeight: 'normal',
        textAlign: 'left',
        fontSize: pxToRem(14),
        lineHeight: '1.43',
        justifyContent: 'flex-start',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
}))
interface ProjectGroupActionPopupInterface {
    projectGroupList?: string[] | undefined
    projectGroupMenuAnchor?: null | Element
    handleProjectGroupMenuClose?: () => void
    handleOpenEditProjectDialog?: (event: React.MouseEvent) => void
    handleOpenRemoveProjectDialog?: (event: React.MouseEvent) => void
}
const ProjectGroupActionPopup: React.FC<ProjectGroupActionPopupInterface> = ({
    projectGroupMenuAnchor,
    handleProjectGroupMenuClose,
    handleOpenEditProjectDialog,
    handleOpenRemoveProjectDialog,
    projectGroupList,
}) => {
    const classes = useStyles()
    const isRemoveDisabled = !projectGroupList || projectGroupList.length <= 1

    return (
        <Popout
            anchorEl={projectGroupMenuAnchor}
            onCloseRequest={handleProjectGroupMenuClose}
            className={clsx(classes.popoutBody, 'actionPopout')}
        >
            <GridContainer direction="column">
                <GridItem className={classes.menuItem}>
                    <Button
                        data-testid="editProjectGroupButton"
                        onClick={handleOpenEditProjectDialog}
                        className={classes.popoutButton}
                        disableRipple={true}
                    >
                        Edit
                    </Button>
                </GridItem>
                <GridItem className={classes.menuItem}>
                    <Button
                        data-testid="deleteProjectGroupButton"
                        disabled={isRemoveDisabled}
                        onClick={handleOpenRemoveProjectDialog}
                        className={classes.popoutButton}
                        disableRipple={true}
                    >
                        Remove
                    </Button>
                </GridItem>
            </GridContainer>
        </Popout>
    )
}
export default ProjectGroupActionPopup
